import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-070a272e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "welcome" }, "Welcome, Stefania")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "create-new" }, "New Assessment", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "orbit-spinner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "orbit" }),
  /*#__PURE__*/_createElementVNode("div", { class: "orbit" }),
  /*#__PURE__*/_createElementVNode("div", { class: "orbit" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Loading Assessments...", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "styled-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Client"),
    /*#__PURE__*/_createElementVNode("th", null, "Assessment"),
    /*#__PURE__*/_createElementVNode("th", null, "Code"),
    /*#__PURE__*/_createElementVNode("th", null, "Created"),
    /*#__PURE__*/_createElementVNode("th", null, "Result")
  ])
], -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "View", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  id: "open-modal",
  class: "modal-window"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Results", -1))
const _hoisted_16 = { class: "styled-table" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Group"),
    /*#__PURE__*/_createElementVNode("th", null, "Value")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoutClicked && _ctx.logoutClicked(...args))),
        class: "logout"
      }, "Logout"),
      _hoisted_2,
      _createVNode(_component_router_link, { to: "/new/session" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      (_ctx.sessions.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessions, (session) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: session.id
            }, [
              _createElementVNode("td", null, _toDisplayString(session.user_name), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.getQuestionnaireName(session.questionnaire_id)), 1),
              _createElementVNode("td", null, _toDisplayString(session.access_code), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(session.created_date)), 1),
              (session.valueGroups)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    class: "view-button",
                    onClick: ($event: any) => (_ctx.viewResultsForSession(session))
                  }, _hoisted_12, 8, _hoisted_10))
                : (_openBlock(), _createElementBlock("td", _hoisted_13, "Assessment Incomplete"))
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              title: "Close",
              class: "modal-close"
            }, "×"),
            _hoisted_15,
            _createElementVNode("div", null, [
              _createElementVNode("table", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedResult, (value, key) => {
                    return (_openBlock(), _createElementBlock("tr", { key: key }, [
                      _createElementVNode("td", null, _toDisplayString(key), 1),
                      _createElementVNode("td", null, _toDisplayString(value), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showModal]
        ])
      ]),
      _: 1
    })
  ], 64))
}